import React from "react";
import DesignSystemComponent from "../../components/test/DesignSystemComponent";
import ChoicesTestComponent from "../../components/test/ChoicesTestComponent";
import RomeoTestComponent from "../../components/test/RomeoTestComponent";
import AllVideoConversionsPage from "./AllVideoConversionsPage";
import VideosPageTest from "./VideosPageTest";
import CheckLinksTabComponent from "../../components/links/CheckLinksTabComponent";
import CustomTabsWithParams from "../../components/widgets/customTabs/CustomTabsWithParams";
import WebappStatsAdminTest from "../../components/test/WebappStatsAdminTest";

const AdminTestPage = () => {

    const contentTabs = [
        {
            eventKey: "welcome",
            title: "Bienvenue",
            mountOnEnter: undefined,
            unmountOnExit: undefined,
            content: <>
                <h2>Bienvenue sur la page de test réservée aux admins M360</h2>
                <p>Cette page est dédiée aux éléments d'analyse ou de test de procédures en interne.</p>
            </>
        },
        {
            eventKey: "designSystem",
            title: "Design system",
            mountOnEnter: undefined,
            unmountOnExit: undefined,
            content: <DesignSystemComponent />
        },
        {
            eventKey: "photolangageChoice",
            title: "Analyse de choix photolangage",
            mountOnEnter: true,
            unmountOnExit: undefined,
            content: <ChoicesTestComponent />
        },
        {
            eventKey: "romeo",
            title: "Test Romeo",
            mountOnEnter: true,
            unmountOnExit: undefined,
            content: <RomeoTestComponent />
        },
        {
            eventKey: "conversion",
            title: "Conversions XP",
            mountOnEnter: true,
            unmountOnExit: undefined,
            content: <AllVideoConversionsPage />
        },
        {
            eventKey: "checkLinks",
            title: "Test liens customs",
            mountOnEnter: true,
            unmountOnExit: undefined,
            content: <CheckLinksTabComponent />
        },
        {
            eventKey: "videos",
            title: "Test recherche videos",
            mountOnEnter: true,
            unmountOnExit: undefined,
            content: <VideosPageTest />
        },
        {
            eventKey: "webappStatsAdminTest",
            title: "Stats webapp",
            mountOnEnter: true,
            unmountOnExit: false,
            content: <WebappStatsAdminTest />
        }
    ]
    return <CustomTabsWithParams
        contentTabs={contentTabs}
        defaultActiveTabId="welcome"
        id="admin-test-tabs"
        className="d-flex mb-4"
    />
}

export default AdminTestPage;